import { render, staticRenderFns } from "./SubjectDetailDialog.vue?vue&type=template&id=12a4fcdf"
import script from "./SubjectDetailDialog.vue?vue&type=script&lang=js"
export * from "./SubjectDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports